import React from 'react';
import { SingleCommonType } from '../../types';
import { starredTagPlaceholder } from '../../constants/placeholder';
import CommonSingleSelect from '../../components/CommonSingleSelect';
import { refundedOptions } from '../../constants/refunded';
import BubbleCommon, {
  steamPerformanceStarTaggedTipsInfo,
} from '@op/components/BubbleCommon';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function StarredTagSelect(props: SingleCommonType) {
  return (
    <BubbleCommon
      showIcon={false}
      placement="top"
      tipsMap={steamPerformanceStarTaggedTipsInfo}
    >
      <CommonSingleSelect
        {...props}
        returnKey="starred_tag"
        dealwithReturnValue={(value) => Number(value)}
        singlePlaceholder={starredTagPlaceholder}
        options={refundedOptions}
        initValue="0"
        pointKey={FilterButtonPoint.starredTag}
      />
    </BubbleCommon>
  );
}
